<section class="jumbotron hero-background" [ngStyle]="{'background-image': 'url(' + currentHeroImage + ')'}">
  <common-home-search></common-home-search>
</section>
